exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".form-group[data-v-5a9c0df3]{font-size:.9rem}.content-header[data-v-5a9c0df3]{background-color:#82ba1d;color:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-5a9c0df3&scoped=true!./~/sass-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/page/partials/Order/Form/PageForm.vue
// module id = 514
// module chunks = 0